import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import { formatPriceValue } from '@propertypal/shared/src/utils/search/inputFormating';
import { Option } from '@propertypal/web-ui/src/inputs/SelectInput';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { selectStyle, StyledSelect } from './SearchBar.style';

interface Props {
  filters: SearchState['filters'];
  minPriceOptions: Option[];
  maxPriceOptions: Option[];
  handleFilterChange: UseSearchState['handleFilterChange'];
  currencySymbol: string;
  isMobile?: boolean;
}

const PriceInputs: FunctionComponent<Props> = ({
  filters,
  minPriceOptions,
  maxPriceOptions,
  handleFilterChange,
  currencySymbol,
  isMobile,
}) => {
  const theme = useTheme();
  const labelStyle = { fontSize: 14, color: theme.primary };

  return (
    <>
      <StyledSelect
        ariaLabel="Choose minimum price"
        containerStyle={{ marginRight: 20 }}
        labelStyle={labelStyle}
        inputStyle={isMobile ? selectStyle : undefined}
        id="selectMinPrice"
        label="Price Range"
        onChange={handleFilterChange('minPrice')}
        options={minPriceOptions}
        placeholder="Minimum Price"
        value={filters.minPrice}
        testID="selectMinPrice"
        wildcard={formatPriceValue('min', currencySymbol)}
      />

      <StyledSelect
        ariaLabel="Choose maximum price"
        labelStyle={labelStyle}
        inputStyle={isMobile ? selectStyle : undefined}
        id="selectMaxPrice"
        label="&nbsp;"
        onChange={handleFilterChange('maxPrice')}
        options={maxPriceOptions}
        placeholder="Maximum Price"
        value={filters.maxPrice}
        testID="selectMaxPrice"
        wildcard={formatPriceValue('max', currencySymbol)}
      />
    </>
  );
};

export default PriceInputs;
